import { MsalAuthenticationResult } from '@azure/msal-react';
import Typography from '@mui/material/Typography';
import React from 'react';

export const ErrorComponent: React.FunctionComponent<MsalAuthenticationResult> = ({ error }) => {
    return <Typography variant="h6">An Error Occurred: {error?.errorCode}</Typography>;
};
